import React from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';

interface StateProps {
  funds?: number;
  bitcoinAmount?: number;
  currency?: string;
}

const ConfirmationPage = () => {
  const history = useHistory();
  const date = moment().format('MMM Do YY');
  const location = useLocation();
  const { funds, bitcoinAmount, currency } = location.state as StateProps;

  return (
    <>
      <MainWrapper>
        <Wrapper>
          <TopWrapper>
            <CheckmarkWrapper>
              <Checkmark></Checkmark>
            </CheckmarkWrapper>
            <Date>{date}</Date>
          </TopWrapper>
          <Header>
            {currency !== 'USD'
              ? `Your Withdraw of ${bitcoinAmount} ${currency} $(${funds}) is processing.`
              : `Your Withdraw of $${funds} is processing.`}
          </Header>

          <Text>
            You can track the status of your withdrawal in the Wallet.
          </Text>
        </Wrapper>
        <Wallet onClick={() => history.push('/user/banking')}>
          Continue to Wallet &#8594;
        </Wallet>
      </MainWrapper>
    </>
  );
};
const Date = styled('span')`
  font-size: 12px;
  opacity: 0.5;
`;
const MainWrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
`;
const TopWrapper = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
const Wrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 19px;

  margin-top: -174px;
  background: #fff;
`;

const Wallet = styled('div')`
  margin-top: 100px;
  cursor: pointer;
`;
const Header = styled('p')`
  font-size: 24px;
  width: 425px;
`;
const Text = styled('p')`
  color: #32343c;
  font-size: 16px;
  width: 425px;

  opacity: 0.5;
  margin-top: -5px;
`;
const CheckmarkWrapper = styled('div')`
  /* border-radius: 100px; */
  display: flex;
  border-radius: 100%;
  background-color: #a2d76b;
  border: 1px solid #a2d76b;
  width: 32px;
  height: 32px;
  /* border: 1px solid black; */
  justify-content: center;
  align-items: center;
`;
const Checkmark = styled('span')`
  font-size: 36px;
  transform: rotate(45deg);
  height: 16px;
  width: 9px;
  border-bottom: 3px solid #fff;
  border-right: 3px solid #fff;
  margin-bottom: 3px;
`;
export default ConfirmationPage;
